var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/_cof.js